import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { FileService } from '../../file-service/file.service';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
// import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../constants/apiurl-constants';
import { EmployeeInformationService } from 'src/app/data-analysis-summary/employee-information/employee-information.service';
import { Messages } from '../../constants/messages';
@Component({
  selector: 'ei-records',
  templateUrl: './ei-records.component.html',
  styleUrls: ['./ei-records.component.scss'],
})
export class EiRecordsComponent implements OnInit {
  currentVersion: any = [];
  employeeRecords: any = [];
  employeeRecordsFiltererd: any = [];
  engagementId: any;
  downloadFile: string = 'Employee_Template.xlsx';
  selectedFileName: string;
  selectedLocation: string;
  isSelected: boolean = false;
  errorMsg: string = 'Employee records could not be exported. Please contact the application support team by clicking the envelope icon on the top right corner of your screen.';
  currentversionvalue: any[] = [];
  currentversion: any;
  currentFileId: number;
  employeeDataexists: boolean = false;
  @Output() drawerWidth = new EventEmitter<any>();
  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    public _toastrService: ToastrService,
    public _sessionService: SessionService,
    public _fileService: FileService,
    public _loader: LoadingIndicatorService,
    private http: HttpClient,
    private _employeeInformationService: EmployeeInformationService,
  ) { }

  // reset form content

  ngOnInit() {
    this.engagementId = this._sessionService.getSession('engagementId');
    this.getEmployeeRecords(this.engagementId);
    this.checkforEmployeeRecords();
    if (this.employeeDataexists) {
      let currentVersion1 = 'Employee Records';
      this.currentversion = {
        TemplateName: currentVersion1,
      };
      this.currentversionvalue.push(this.currentversion);
    }
    this.drawerWidth.emit('calc(46vw - 100px)');
  }
  checkforEmployeeRecords() {
    if (
      this._employeeInformationService.employeeInformationApiCallData.result
        .length > 0
    ) {
      this.employeeDataexists = true;
    }
  }

  downloadTemplate() {
    let downloadFileName = 'Employee_Template.xlsx';
    this._fileService.download(downloadFileName).subscribe(data => {
      this._fileService.saveBlobToFile(data, downloadFileName);
    });
  }

  getEmployeeRecords(engagementId: any) {
    this._sessionService.apiUrlGet(API_URL.GETUPLOADDATAFILE + '?engagementId=' + engagementId + '&fileType=1').subscribe(data => {
      this.employeeRecords = data;
      this.employeeRecordsFiltererd = this.employeeRecords.result.filter(
        item => item.location !== null && item.fileType === 1,
      );
    });
  }

  downloadSelected(fileId) {
    this._loader.display(true, true);
    this.rightSideDrawerService.closeRightSideDrawer();
    if (fileId === -1) {
      this._sessionService
        .downloadAsFileGet(
          API_URL.GENERATEEMPLOYEEDATAFILE +
          '?engagementId=' +
          this.engagementId,
        )
        .subscribe(
          blob => {
            this._toastrService.setSuccessMessage(
              Messages.DownloadEmployees.DownloadSuccess,
            );
            this._fileService.saveBlobToFile(blob, `Employee_details.xlsx`);
            this.rightSideDrawerService.closeRightSideDrawer();
            this._loader.display(false);
          });
    } else {
      this._sessionService
        .downloadAsFileGet(
          API_URL.DOWNLOADDATAFILE +
          '?fileId=' +
          fileId +
          '&engagementId=' +
          this.engagementId,
        )
        .subscribe(
          blob => {
            let fileName: string = this.employeeRecordsFiltererd.filter(
              (item: any) => item.fileId === fileId,
            )[0].fileName;
            this._toastrService.setSuccessMessage(
              Messages.DownloadEmployees.DownloadFileSuccess,
            );
            this.rightSideDrawerService.closeRightSideDrawer();
            this._fileService.saveBlobToFile(blob, `${fileName}`);
            this._loader.display(false);
          });
    }
  }
}
